import { Model } from "@vuex-orm/core";

export default class RedirectLink extends Model {
  static entity = "redirectLink";

  static fields() {
    return {};
  }
}
